import { render, staticRenderFns } from "./Location.page.vue?vue&type=template&id=ef6b3070&"
import script from "./Location.page.vue?vue&type=script&lang=js&"
export * from "./Location.page.vue?vue&type=script&lang=js&"
import style0 from "./Location.page.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports